// El vocabulario del canal de nacimiento de una observación
// (`findings.intake_channel`) — una sola fuente para el CHECK de la base,
// el enum `origen` del wire y los predicados que se comportan distinto
// según quién la contó.
//
//   - `acta`                 hallazgo o captura dentro de un reporte;
//   - `observacion_suelta`   el personal la levantó sobre la unidad
//                            (POST /assets/:id/observations, brazo suelto);
//   - `reporte_propietario`  el propietario la reportó desde su PWA
//                            (ADR-0125);
//   - `consulta_propietario` el jefe del proyecto (o un gerente) convirtió
//                            una consulta del propietario en observación
//                            (ADR-0163, #0770). La contó el propietario; la
//                            clasificó una persona del equipo.
//
// Los dos últimos son «del propietario» (`OWNER_AUTHORED_INTAKE_CHANNELS`):
// el gate de confianza los exime y el hilo los pinta desde el carril de la
// contraparte. Donde importa QUIÉN la contó (el actor «Tú», las palabras del
// propietario, el enlace a la consulta), `consulta_propietario` además mira
// al autor de la consulta: un dueño posterior de la unidad no es el autor.
export const INTAKE_CHANNELS = [
    "acta",
    "observacion_suelta",
    "reporte_propietario",
    "consulta_propietario",
];
/** Los canales en que la observación la contó el propietario. */
export const OWNER_AUTHORED_INTAKE_CHANNELS = [
    "reporte_propietario",
    "consulta_propietario",
];
/** ¿La contó el propietario? NULL (canal desconocido) es «no»: falla
 *  cerrado, igual que el gate de confianza. */
export function isOwnerAuthoredIntake(channel) {
    return OWNER_AUTHORED_INTAKE_CHANNELS.includes(channel ?? "");
}
//# sourceMappingURL=intake-channel.js.map